export interface FormsStateInterface {
  activeFormToken: string;
}

export const initFormsState: FormsStateInterface = {
  activeFormToken: null,
};
